import { HiOutlineDocumentReport } from "react-icons/hi";

import { Button } from "@/components/ui/button/button";
import { usePerformanceReportsModal } from "./use-performance-reports-modal";
import { PerformanceReportsModal } from "./performance-reports-modal";

export const HomePerformanceReportCard = () => {
  const { onOpenChange } = usePerformanceReportsModal();

  return (
    <div className="w-60 h-24 rounded-md bg-card flex flex-col gap-1 shadow-sm border p-4">
      <div className="flex flex-row items-center pb-2 justify-between">
        <h2 className="text-sm font-medium">My Performance</h2>

        <HiOutlineDocumentReport className="w-4 h-4" />
      </div>
      <div className="">
        <Button
          variant="default"
          size="sm"
          onClick={() => {
            onOpenChange(true);
          }}
        >
          View
        </Button>
      </div>

      <PerformanceReportsModal />
    </div>
  );
};
